import React from 'react';
import styled from 'styled-components/macro';

import { OpenConvalidaResponse } from 'models/response';

import utils from 'utils';

import Dropdown from 'components/Input/dropdown/Dropdown';
import { fontSizePalette, fontWeightPalette } from 'utils/styleConstants';

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 35px 0;
  > div {
    margin-right: 5px;
  }
`;
const Label = styled.p`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${fontSizePalette.medium};
  font-weight: ${fontWeightPalette.medium};
  letter-spacing: -0.5px;
  line-height: 19px;
  margin-right: 8px;
`;

interface Props {
  response: OpenConvalidaResponse;
}

const Close = (props: Props) => {
  const { response } = props;
  const t = utils.intl.useTranslator();

  return (
    <SelectWrapper>
      <Label>{t('destinatario')}: </Label>
      <div>
        <Dropdown
          id="user-dropdown"
          name="user"
          disabled={true}
          value={{
            label: response.finalDestinationUser?.name,
            value: response.finalDestinationUser?.idUser,
          }}
          options={[
            {
              label: response.finalDestinationUser?.name,
              value: response.finalDestinationUser?.idUser,
            },
          ]}
        />
      </div>
    </SelectWrapper>
  );
};

export default Close;
